<template>
  <component
    :is="component"
    class="simple-card"
    :class="{ 'simple-card--loading': loading }"
    v-bind="attrs"
    @click="$emit('navigate')"
  >
    <template v-if="!loading">
      <span class="simple-card__label">{{ label }}</span>
      <div class="simple-card__wrap-value">
        <span class="simple-card__value">{{ modelValue }}</span>
        <span v-if="to" class="simple-card__link">
          <OpenIcon16 />
        </span>
      </div>
    </template>
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import OpenIcon16 from '@components/Icons/OpenIcon16.vue';

export default defineComponent({
  emits: { navigate: null },
  name: 'SimpleCard',

  components: {
    OpenIcon16,
  },

  props: {
    label: {
      type: String,
      required: true,
    },

    modelValue: {
      type: String || Number,
      required: true,
    },

    to: {
      type: [String, Object],
      default: null,
    },

    href: {
      type: String,
      default: null,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    attrs() {
      let href = '';

      if (this.to) {
        href = this.$router.resolve(this.to).href;
      } else if (this.href) {
        href = this.href;
      }

      return {
        href,
        target: '_blank',
      };
    },

    component() {
      if (this.to || this.href) {
        return 'a';
      }

      return 'div';
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';
@use 'mixins/typography';
@use 'helpers/loading-gradient-animation';

.simple-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 8px;
  border-radius: settings.$border-radius * 2;
  border: settings.$simple-card-border;

  flex: 1;
  min-width: 245.33px;
  height: 90px;

  &:hover {
    background-color: colors.$color-grey-200;
  }

  &--loading {
    pointer-events: none;
    border: none;

    @extend .loading-gradient-animation;
  }
}

.simple-card__label {
  @include typography.typography-14-normal(160%);
}

.simple-card__wrap-value {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.simple-card__value {
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
}
</style>
